import { Controller } from "react-hook-form";

import { ToolSectionHeader } from "@/components/Assistant/ToolSectionHeader";
import { BetaFieldContext } from "@/components/Form/NoxusFormLabel";
import type { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";
import type { SkillConfig } from "@/generated";
import { SkillsField } from "./SkillsField";

export const SkillsFieldWithHeader = ({
  form,
  idFieldKey,
  config,
  isDisabled,
}: {
  form: ReturnType<typeof import("react-hook-form").useFormContext>;
  idFieldKey: string;
  config: NoxusFormEntryConfig;
  isDisabled?: boolean;
}) => (
  // No enable toggle: an agent either has skills or it does not, and the
  // backend loads the capability only when there is an enabled one.
  <div className="flex flex-col gap-3">
    <ToolSectionHeader
      title="Skills"
      subtitle="Extend agent capabilities with markdown-based skill packages"
      isDisabled={isDisabled}
    />

    {/* The header above already carries the Beta badge for this section.
        Descendants inherit the same context (through the editor's portal too),
        so every label inside would repeat the word. */}
    <BetaFieldContext.Provider value={false}>
      <Controller
        control={form.control}
        name={idFieldKey}
        defaultValue={config.default}
        render={({ field }) => (
          <SkillsField
            skills={field.value as SkillConfig[] | undefined}
            onSkillsChange={field.onChange}
            isDisabled={isDisabled}
          />
        )}
      />
    </BetaFieldContext.Provider>
  </div>
);
